export default {"src":"/_next/static/media/support-icon.491d8f54.svg","height":1600,"width":1600};